import { render, staticRenderFns } from "./ComboCanalLead.vue?vue&type=template&id=61182eca"
import script from "./ComboCanalLead.vue?vue&type=script&lang=ts"
export * from "./ComboCanalLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports